import { extractType } from '@atlaskit/link-extractors';
import { extractState } from './extractState';
import { extractTag } from './extractTag';
import { extractTaskStatus } from './extractTaskStatus';
import { extractTaskType } from './extractTaskType';
export var extractLozenge = function extractLozenge(jsonLd) {
  var type = extractType(jsonLd);
  if (type) {
    if (type.includes('atlassian:Task')) {
      var jsonLdTask = jsonLd;
      var lozengeFromTag = extractTag(jsonLdTask);
      var lozengeFromStatus = extractTaskStatus(jsonLdTask);
      var lozengeFromTaskType = extractLozengeFromTaskType(jsonLdTask);
      return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
    }
    if (type.includes('atlassian:UndefinedLink')) {
      return {
        text: 'UNDEFINED',
        appearance: 'inprogress'
      };
    }

    // casting it because `extractState` can safely handle missing properties
    return extractState(jsonLd);
  }
};
var extractLozengeFromTaskType = function extractLozengeFromTaskType(jsonLdTask) {
  var taskType = extractTaskType(jsonLdTask);
  if (taskType && taskType.name) {
    return {
      text: taskType.name,
      appearance: 'success'
    };
  }
};